module.exports = __webpack_public_path__ + "img/image_part_004.c877b308.jpg";